import React, { useEffect } from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { AuthoritySection } from './components/AuthoritySection';
import { BonusSection } from './components/BonusSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { OfferSection } from './components/OfferSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
import { PurchasePopup } from './components/PurchasePopup';
import { FloatingCTA } from './components/FloatingCTA';
export function App() {
  useEffect(() => {
    // --- INTEGRACIÓN META PIXEL (VERSIÓN SEGURA) ---
    // @ts-ignore
    if (!window.fbq) {
      // @ts-ignore
      !function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        document.head.appendChild(t);
      }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

      // @ts-ignore
      fbq('init', '1017864240671808');
      // @ts-ignore
      fbq('track', 'PageView');
    }
  }, []);
  return <div className="min-h-screen bg-white font-sans selection:bg-brand-yellow selection:text-black" data-id="element-0">
      <HeroSection data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <SolutionSection data-id="element-3" />
      <AuthoritySection data-id="element-4" />
      <BonusSection data-id="element-5" />
      <TestimonialsSection data-id="element-6" />
      <OfferSection data-id="element-7" />
      <FAQSection data-id="element-8" />
      <FinalCTASection data-id="element-9" />

      <PurchasePopup data-id="element-10" />
      <FloatingCTA data-id="element-11" />

      {/* Custom animations for popup and floating CTA */}
      <style dangerouslySetInnerHTML={{
      __html: `
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .animate-fade-in-up {
          animation: fadeInUp 0.5s ease-out forwards;
        }
      `
    }} data-id="element-12" />
    </div>;
}